// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isSaturday/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isSaturday = convertToFP(fn, 1);
export default isSaturday;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/isSaturday/index.js
// module id = 940
// module chunks = 0